import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/style.less'
import './assets/font/iconfont.css'
require('./Mock')
import {parseTime} from './utils'
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css'	//样式
    import '@/assets/css/audioplayer/initaudioplayer-1.css'



//引用element
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';//使用
import videojs from "video.js"
import "video.js/dist/video-js.css";

import { Message, MessageBox } from 'element-ui'

Vue.use(Element, Message, MessageBox);

import vant from './ui/vant'
import 'vant/lib/index.css';
Vue.use(vant)



Vue.directive('highlight',function (el) {
  let blocks = el.querySelectorAll('pre code');
  blocks.forEach((block)=>{
    hljs.highlightBlock(block)
  })
  
})

Vue.config.productionTip = false
Vue.filter('parseTime', (v) => parseTime(v,'{y}-{m}-{d}'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
